var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sparkle_svg__clip0_9433_820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5.604l.659 1.237 1.236.66-1.236.659-.66 1.236-.66-1.236-1.235-.66 1.236-.66L8.5.605zM4 2.167l1.333 2.5L7.833 6l-2.5 1.334-1.334 2.5-1.333-2.5L.166 6l2.5-1.333 1.333-2.5zm5.833 6l-.834-1.562-.833 1.562L6.604 9l1.562.834.833 1.562.834-1.562L11.395 9l-1.562-.833z",
    fill: "#EAEEB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sparkle_svg__clip0_9433_820"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/sparkle.svg";
export { SvgSparkle as ReactComponent };